enum ConnectionPositionEnum {
    above,
    below,
    default,
}

export default ConnectionPositionEnum;
